__turbopack_context__.v({
  "active": "FeaturedReviews-module__qGuFZW__active",
  "bullet": "FeaturedReviews-module__qGuFZW__bullet",
  "carousel-pointers": "FeaturedReviews-module__qGuFZW__carousel-pointers",
  "carouselPointer": "FeaturedReviews-module__qGuFZW__carouselPointer",
  "content": "FeaturedReviews-module__qGuFZW__content",
  "description": "FeaturedReviews-module__qGuFZW__description",
  "description-wrapper": "FeaturedReviews-module__qGuFZW__description-wrapper",
  "embla": "FeaturedReviews-module__qGuFZW__embla",
  "embla__container": "FeaturedReviews-module__qGuFZW__embla__container",
  "embla__dot": "FeaturedReviews-module__qGuFZW__embla__dot",
  "embla__dot--selected": "FeaturedReviews-module__qGuFZW__embla__dot--selected",
  "embla__dots": "FeaturedReviews-module__qGuFZW__embla__dots",
  "embla__slide": "FeaturedReviews-module__qGuFZW__embla__slide",
  "load": "FeaturedReviews-module__qGuFZW__load",
  "progress": "FeaturedReviews-module__qGuFZW__progress",
  "quote-wrapper": "FeaturedReviews-module__qGuFZW__quote-wrapper",
  "quoteCarousel": "FeaturedReviews-module__qGuFZW__quoteCarousel",
  "quoteCarousel1": "FeaturedReviews-module__qGuFZW__quoteCarousel1",
  "root": "FeaturedReviews-module__qGuFZW__root",
  "space": "FeaturedReviews-module__qGuFZW__space",
});
